var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDriftdetection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_157",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 57
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.55 49.875L31.5875 34.9125C30.4 35.8625 29.0344 36.6146 27.4906 37.1688C25.9469 37.7229 24.3042 38 22.5625 38C18.2479 38 14.5964 36.5057 11.6078 33.5172C8.61927 30.5286 7.125 26.8771 7.125 22.5625C7.125 18.2479 8.61927 14.5964 11.6078 11.6078C14.5964 8.61927 18.2479 7.125 22.5625 7.125C26.8771 7.125 30.5286 8.61927 33.5172 11.6078C36.5057 14.5964 38 18.2479 38 22.5625C38 24.3042 37.7229 25.9469 37.1688 27.4906C36.6146 29.0344 35.8625 30.4 34.9125 31.5875L49.875 46.55L46.55 49.875ZM22.5625 33.25C25.5312 33.25 28.0547 32.2109 30.1328 30.1328C32.2109 28.0547 33.25 25.5312 33.25 22.5625C33.25 19.5938 32.2109 17.0703 30.1328 14.9922C28.0547 12.9141 25.5312 11.875 22.5625 11.875C19.5938 11.875 17.0703 12.9141 14.9922 14.9922C12.9141 17.0703 11.875 19.5938 11.875 22.5625C11.875 25.5312 12.9141 28.0547 14.9922 30.1328C17.0703 32.2109 19.5938 33.25 22.5625 33.25Z",
    fill: "#014AAA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriftdetection);
export default __webpack_public_path__ + "static/media/drift detection.5095cc7f9749cd180c6f63bdfbb6ae58.svg";
export { ForwardRef as ReactComponent };